
export default {
  auth: false,
  data: () => ({
    loading: false,
    success: false,
    form: {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      password_confirmation: null,
      newsletter: false,
    },
  }),
  methods: {
    async submit() {
      await this.$store.dispatch('validation/clearErrors');
      this.loading = true;
      try {
        const payload = {
          ...this.form,
          name: `${this.form.first_name} ${this.form.last_name}`,
        };
        await this.$axios.post('register', payload);
        this.success = true;

        this.$gtm.push({event: 'registration_form', first_field_name: this.form.newsletter});
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
